import { FC, useRef } from 'react';
import { useDrop, useDrag } from 'react-dnd';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
// interfaces
import { DraggableIngredientRowProps } from 'interfaces/index';

const DraggableIngredientRow: FC<DraggableIngredientRowProps> = ({ index, move, canDrag, children }) => {
  const ref = useRef<HTMLDivElement>(null);

  const [, drop] = useDrop({
    accept: 'ingredient',
    hover(dragged: { index: number }) {
      if (!ref.current || dragged.index === index) return;
      move(dragged.index, index);
      dragged.index = index;
    },
  });

  const [{ isDragging }, drag, preview] = useDrag({
    type: 'ingredient',
    item: { index },
    canDrag,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <div ref={preview} style={{ opacity: isDragging ? 0.5 : 1 }}>
      <div ref={ref} style={{ display: 'flex', alignItems: 'center' }}>
        {canDrag ? (
          <span style={{ cursor: 'grab', marginRight: 8 }}>
            <DragIndicatorIcon fontSize="large" />
          </span>
        ) : (
          <span style={{ width: 24, marginRight: 8 }} />
        )}
        {children}
      </div>
    </div>
  );
};

export default DraggableIngredientRow;
